
import { Hidden, IconButton, Menu, MenuItem } from '@material-ui/core';
import { GridMenuIcon } from '@material-ui/data-grid';
import { useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ButtonRef } from '../../../../Interfaces/Interfaces';

const NavMenu = () => {
    const menuRef = useRef<ButtonRef>(null);
    const [menuAnchor, setMenuAnchor] = useState<ButtonRef>(menuRef.current)

	return (
        <Hidden only={["sm","md", "lg", "xl"]}>
            <IconButton
                onClick={() => { setMenuAnchor(menuRef.current) }}
                id="menu"
                edge="start"
                color="secondary"
                aria-label="nav-menu">
                <GridMenuIcon
                    innerRef={menuRef}
                />
            </IconButton>
            <Menu
                id="nav-menu"
                anchorEl={menuAnchor}
                keepMounted
                open={Boolean(menuAnchor)}
                onClose={() => { setMenuAnchor(null) }}
            >
                <MenuItem onClick={() => { setMenuAnchor(null) }} component={NavLink} to="/">Home</MenuItem>
                <MenuItem onClick={() => { setMenuAnchor(null) }} component={NavLink} to="/Campaigns">Campaigns</MenuItem>
                <MenuItem onClick={() => { setMenuAnchor(null) }} component={NavLink} to="/Missions">Missions</MenuItem>
            </Menu>
        </Hidden>
	)
}
export default NavMenu ;
